import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { EmailTemplate, SentEmail } from '@erp/shared';

export function emailTemplatesOptions() {
  return queryOptions({
    queryKey: ['erp', 'mail', 'templates'] as const,
    queryFn: async ({ signal }) => {
      const res = await api<EmailTemplate[]>('/mail/templates', { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

export function mailLogOptions(ticketNumber?: number) {
  return queryOptions({
    queryKey: ['erp', 'mail', 'log', { ticketNumber }] as const,
    queryFn: async ({ signal }) => {
      const res = await api<SentEmail[]>('/mail/log', {
        query: { ticket_number: ticketNumber },
        signal,
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
